import request from '@/request'

/**
 * 群列表清单
 * @returns {AxiosPromise}
 */
export function qq_list(data) {
  const url = '/api/v1/qq/list'
  return request({ url, method: 'POST', data: data })
}

/**
 * 群列表清单
 * @returns {AxiosPromise}
 */
export function get_new_group_list(data) {
  const timeout = 600000
  const url = '/api/v1/qq/get_group_list'
  return request({ url, timeout, method: 'POST', data: data })
}

/**
 * 群详情
 * @returns {AxiosPromise}
 */
export function get_group_detail(data) {
  const url = '/api/v1/qq/get_group_detail'
  return request({ url, method: 'POST', data: data })
}

/**
 * 群成员列表
 * @returns {AxiosPromise}
 */
export function get_group_member_list(data) {
  const url = '/api/v1/qq/member_list'
  return request({ url, method: 'POST', data: data })
}

/**
 * 检测用户是否存在
 * @returns {AxiosPromise}
 */
export function user_verify(data) {
  const url = '/api/v1/qq/user_verify'
  return request({ url, method: 'POST', data: data })
}

/**
 * 检测群号是否存在
 * @returns {AxiosPromise}
 */
export function group_verify(data) {
  const url = '/api/v1/qq/group_verify'
  return request({ url, method: 'POST', data: data })
}

/**
 * 单独拉取群信息
 * @returns {AxiosPromise}
 */
export function pull_group(data) {
  const url = '/api/v1/qq/pull_group'
  return request({ url, method: 'POST', data: data })
}

/**
 * 获取负责群的列表
 * @returns {AxiosPromise}
 */
export function my_group(data) {
  const url = '/api/v1/qq/my_group'
  return request({ url, method: 'POST', data: data })
}

/**
 * 导出负责群的列表
 * @param data
 * @returns {AxiosPromise}
 */
export function export_group(data) {
  const url = '/api/v1/qq/export_group'
  return request({
    url,
    responseType: 'blob',
    timeout: 200000,
    method: 'POST',
    data: data,
  })
}

/**
 * 单独拉取群信息
 * @returns {AxiosPromise}
 */
export function band_group(data) {
  const url = '/api/v1/qq/band'
  return request({ url, method: 'POST', data: data })
}

/**
 * 社群修改
 * @param data
 * @returns {AxiosPromise}
 */
export function qq_modify(data) {
  const url = '/api/v1/qq/modify'
  return request({ url, method: 'POST', data: data })
}

/**
 * QQ创建题集
 * @param data
 * @returns {AxiosPromise}
 */
export function modify_exam_group(data) {
  const url = '/api/v1/qq/modify_exam_group'
  return request({ url, method: 'POST', data: data })
}

/**
 * 获取题集
 * @param data
 * @returns {AxiosPromise}
 */
export function get_exam_group(params) {
  const url = '/api/v1/qq/get_exam_group'
  return request({ url, method: 'GET', params })
}

/**
 * 上传题目
 * @param data
 * @returns {AxiosPromise}
 */
export function modify_exam(data) {
  const url = '/api/v1/qq/modify_exam'
  return request({ url, method: 'POST', data })
}

/**
 * 获取题目列表
 * @param data
 * @returns {AxiosPromise}
 */
export function get_exam(params) {
  const url = '/api/v1/qq/get_exam'
  return request({ url, method: 'GET', params })
}

/**
 * 绑定题集
 * @param data
 * @returns {AxiosPromise}
 */
export function modify_band_exam(data) {
  const url = '/api/v1/qq/modify_band_exam'
  return request({ url, method: 'POST', data })
}

/**
 * 移除绑定题集(软删除)
 * @param data
 * @returns {AxiosPromise}
 */
export function remove_band_exam(data) {
  const url = '/api/v1/qq/remove_band_exam'
  return request({ url, method: 'POST', data })
}

/**
 * 获取绑定题集列表
 * @param data
 * @returns {AxiosPromise}
 */
export function get_band_list(params) {
  const url = '/api/v1/qq/get_band_list'
  return request({ url, method: 'GET', params })
}
/**
 * 设置题集时间间隔
 * @param data
 * @returns {AxiosPromise}
 */
export function set_exam_interval(data) {
  const url = '/api/v1/qq/set_exam_interval'
  return request({ url, method: 'POST', data })
}

/**
 * 重置答题进度(需要重新开启答题)
 * @param data
 * @returns {AxiosPromise}
 */
export function redo_test(data) {
  const url = '/api/v1/qq/redo_test'
  return request({ url, method: 'POST', data })
}
